import useMarkOnMount from 'crm-fe-perf/timing/hooks/useMarkOnMount';
import { RecordTimelineMounted } from 'crm-fe-perf/timing/marks/crm-records-ui/performanceMarks';
import RecordTimelineRouter from '../crm_ui/timeline/components/config/RecordTimelineRouter';
// @ts-expect-error Could not find a declaration file
import { AnyCrmObjectTypePropType } from 'customer-data-objects-ui-components/propTypes/CrmObjectTypes';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import { useCallback, useMemo } from 'react';
import { ScreenReaderOnly } from 'foundations-components/transitional/components/ScreenReaderOnly';
import { useActivityQuickViewModalActionHandler } from './useActivityQuickViewModalActionHandler';
import { useAlertsActionHandler } from './useAlertsActionHandler';
import { useAttachmentFileManagerActionHandler } from './useAttachmentFileManagerActionHandler';
import { useAttachmentsActionHandler } from './useAttachmentsActionHandler';
import { useBizOpsStoreActionHandler } from './useBizOpsStoreActionHandler';
import { useCommunicatorActionHandler } from './useCommunicatorActionHandler';
import { useDeleteCallRecordingModalActionHandler } from './useDeleteCallRecordingModalActionHandler';
import { useDeleteCallVoicemailModalActionHandler } from './useDeleteCallVoicemailModalActionHandler';
import { useDeleteCommentModalActionHandler } from './useDeleteCommentModalActionHandler';
import { useDeleteModalActionHandler } from './useDeleteModalActionHandler';
import { useEditSequenceModalActionHandler } from './useEditSequenceModalActionHandler';
import { useEngagementHistoryActionHandler } from './useEngagementHistoryActionHandler';
import { useImagePickerActionHandler } from './useImagePickerActionHandler';
import { useIntegrationModalActionHandler } from './useIntegrationModalActionHandler';
import { usePortalUsersPanelActionHandler } from './usePortalUsersPanelActionHandler';
import { useRemoveAttachmentModalActionHandler } from './useRemoveAttachmentModalActionHandler';
import { useReplacePinnedEngagementModalActionHandler } from './useReplacePinnedEngagementModalActionHandler';
import { useTaskQueueActionHandler } from './useTaskQueueActionHandler';
import { useTaskUpdateActionHandler } from './useTaskUpdateActionHandler';
import { useTimelineNavigationActionHandler } from './useTimelineNavigationActionHandler';
import { useTimelineRhumbActionHandler } from './useTimelineRhumbActionHandler';
import { useTranscriptSidebarActionHandler } from './useTranscriptSidebarActionHandler';
import { useUnenrollSequenceModalActionHandler } from './useUnenrollSequenceModalActionHandler';
import { useViewSequenceModalActionHandler } from './useViewSequenceModalActionHandler';
import { usePreviewSidebarActionHandler } from './usePreviewSidebarActionHandler';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function RecordTimeline({
  activeTaskId,
  auth,
  currentOwnerId,
  currentUserCanCommunicate,
  currentUserCanEdit,
  objectType,
  query,
  subjectId
}) {
  useMarkOnMount(RecordTimelineMounted);
  const {
    handleNavigationAction
  } = useTimelineNavigationActionHandler();
  const {
    handleCommunicatorAction
  } = useCommunicatorActionHandler({
    objectType,
    subjectId
  });
  const {
    handleTranscriptSidebarAction,
    transcriptSidebar
  } = useTranscriptSidebarActionHandler({
    query
  });
  const {
    handleTimelineRhumbAction,
    rhumbMarker
  } = useTimelineRhumbActionHandler();
  const {
    handleDeleteModalAction,
    deleteModal
  } = useDeleteModalActionHandler({
    objectType,
    subjectId
  });
  const {
    handleDeleteCommentModalAction,
    commentDeleteModal
  } = useDeleteCommentModalActionHandler();
  const {
    handleEngagementHistoryAction,
    engagementHistoryWrapper
  } = useEngagementHistoryActionHandler();
  const {
    handleEditSequenceModalAction,
    editSequenceModal
  } = useEditSequenceModalActionHandler({
    objectType,
    subjectId
  });
  const {
    handleUnenrollSequenceModalAction,
    unenrollSequenceModal
  } = useUnenrollSequenceModalActionHandler({
    query,
    objectType,
    subjectId
  });
  const {
    handleTaskQueueAction
  } = useTaskQueueActionHandler({
    objectType,
    subjectId
  });
  const {
    handleTaskUpdateAction
  } = useTaskUpdateActionHandler();
  const {
    handleViewSequenceModalAction,
    viewSequenceModal
  } = useViewSequenceModalActionHandler();
  const {
    handleAttachmentsAction
  } = useAttachmentsActionHandler(objectType, subjectId);
  const {
    handleRemoveAttachmentModalAction,
    removeAttachmentModal
  } = useRemoveAttachmentModalActionHandler(objectType, subjectId);
  const {
    handleDeleteCallRecordingModalAction,
    deleteCallRecordingModal
  } = useDeleteCallRecordingModalActionHandler({
    objectType
  });
  const {
    handleDeleteCallVoicemailModalAction,
    deleteCallVoicemailModal
  } = useDeleteCallVoicemailModalActionHandler({
    objectType
  });
  const {
    handleAlertsAction
  } = useAlertsActionHandler();
  const {
    handleIntegrationModalAction,
    integrationModal
  } = useIntegrationModalActionHandler();
  const {
    handleReplacePinnedEngagementModalAction,
    replacePinnedEngagementModal
  } = useReplacePinnedEngagementModalActionHandler({
    objectType,
    subjectId
  });
  const {
    handleImagePickerAction,
    imagePicker
  } = useImagePickerActionHandler({
    auth
  });
  const {
    handleAttachmentFileManagerAction,
    attachmentFileManager
  } = useAttachmentFileManagerActionHandler({
    auth
  });
  const {
    handleActivityQuickViewModalAction,
    activityQuickViewModal
  } = useActivityQuickViewModalActionHandler();
  const {
    handlePortalUsersPanelAction,
    portalUsersPanel
  } = usePortalUsersPanelActionHandler();
  const {
    handleBizOpsStoreAction
  } = useBizOpsStoreActionHandler();
  const {
    handlePreviewSidebarAction
  } = usePreviewSidebarActionHandler();
  const handleReceiveTimelineAction = useCallback((type, data) => {
    handleTranscriptSidebarAction(type, data);
    handleEditSequenceModalAction(type, data);
    handleNavigationAction(type, data);
    handleEngagementHistoryAction(type, data);
    handleCommunicatorAction(type, data);
    handleTimelineRhumbAction(type);
    handleDeleteModalAction(type, data);
    handleUnenrollSequenceModalAction(type, data);
    handleTaskQueueAction(type, data);
    handleTaskUpdateAction(type, data);
    handleViewSequenceModalAction(type, data);
    handleAttachmentsAction(type, data);
    handleRemoveAttachmentModalAction(type, data);
    handleDeleteCallRecordingModalAction(type, data);
    handleDeleteCallVoicemailModalAction(type, data);
    handleAlertsAction(type, data);
    handleIntegrationModalAction(type, data);
    handleReplacePinnedEngagementModalAction(type, data);
    handleImagePickerAction(type);
    handleAttachmentFileManagerAction(type);
    handleActivityQuickViewModalAction(type, data);
    handlePortalUsersPanelAction(type, data);
    handleBizOpsStoreAction(type, data);
    handleDeleteCommentModalAction(type, data);
    handlePreviewSidebarAction(type, data);
  }, [handleTranscriptSidebarAction, handleEditSequenceModalAction, handleNavigationAction, handleEngagementHistoryAction, handleCommunicatorAction, handleTimelineRhumbAction, handleDeleteModalAction, handleUnenrollSequenceModalAction, handleTaskQueueAction, handleTaskUpdateAction, handleViewSequenceModalAction, handleAttachmentsAction, handleRemoveAttachmentModalAction, handleDeleteCallRecordingModalAction, handleDeleteCallVoicemailModalAction, handleAlertsAction, handleIntegrationModalAction, handleReplacePinnedEngagementModalAction, handleImagePickerAction, handleAttachmentFileManagerAction, handleActivityQuickViewModalAction, handlePortalUsersPanelAction, handleBizOpsStoreAction, handleDeleteCommentModalAction, handlePreviewSidebarAction]);
  const timeline = useMemo(() => {
    return /*#__PURE__*/_jsx(RecordTimelineRouter, {
      activeTaskId: activeTaskId,
      auth: auth,
      currentOwnerId: currentOwnerId,
      currentUserCanCommunicate: currentUserCanCommunicate,
      currentUserCanEdit: currentUserCanEdit,
      objectType: objectType,
      query: query,
      subjectId: subjectId,
      postTimelineActionToRecord: handleReceiveTimelineAction
    });
  }, [activeTaskId, auth, currentOwnerId, currentUserCanCommunicate, currentUserCanEdit, handleReceiveTimelineAction, objectType, query, subjectId]);
  return /*#__PURE__*/_jsx("main", {
    id: "main-content",
    "aria-label": I18n.text('timeline.accessibility.timelineHeading'),
    children: /*#__PURE__*/_jsxs(View, {
      blockSize: "100%",
      children: [/*#__PURE__*/_jsx(ScreenReaderOnly, {
        children: /*#__PURE__*/_jsx("h2", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "timeline.accessibility.timelineHeading"
          })
        })
      }), engagementHistoryWrapper, transcriptSidebar, editSequenceModal, viewSequenceModal, unenrollSequenceModal, removeAttachmentModal, timeline, rhumbMarker, deleteModal, integrationModal, replacePinnedEngagementModal, imagePicker, attachmentFileManager, activityQuickViewModal, portalUsersPanel, commentDeleteModal, deleteCallRecordingModal, deleteCallVoicemailModal]
    })
  });
}
RecordTimeline.propTypes = {
  activeTaskId: PropTypes.number,
  auth: PropTypes.object,
  currentOwnerId: PropTypes.number,
  currentUserCanCommunicate: PropTypes.bool,
  currentUserCanEdit: PropTypes.bool,
  objectType: AnyCrmObjectTypePropType.isRequired,
  query: PropTypes.shape({
    callSidebarOpen: PropTypes.string,
    interaction: PropTypes.string,
    engagement: PropTypes.string,
    unenrollSequenceModalOpen: PropTypes.string
  }),
  subjectId: PropTypes.string.isRequired
};
export default RecordTimeline;